import React, { useState } from 'react';
import ProjectCard from './ProjectCard';
import { projectsData } from './projectsData';
import { projects2025Data } from './projects2025Data';

export const UnifiedProjectsPage = () => {
  const [selectedYear, setSelectedYear] = useState('2024');

  const currentData = selectedYear === '2024' ? projectsData : projects2025Data;
  const currentTitle = selectedYear === '2024' ? 'Проведенные курсы 2024' : 'Проведенные курсы 2025';

  return (
    <section id='coursesTaught' className="py-12 md:pb-16 lg:pb-20 font-montserrat">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex justify-center mb-8">
          <div className="bg-gray-100 rounded-lg p-1 inline-flex">
            <button
              onClick={() => setSelectedYear('2024')}
              className={`px-6 py-2 rounded-md font-semibold transition-all duration-200 ${
                selectedYear === '2024'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              2024
            </button>
            <button
              onClick={() => setSelectedYear('2025')}
              className={`px-6 py-2 rounded-md font-semibold transition-all duration-200 ${
                selectedYear === '2025'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              2025
            </button>
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-8 md:mb-12">
          {currentTitle}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
          {currentData.map((project) => (
            <ProjectCard
              key={`${selectedYear}-${project.id}`}
              id={project.id}
              title={project.title}
              imageUrl={project.imageUrl}
              year={selectedYear}
            />
          ))}
        </div>

        <div className="text-center mt-8 text-gray-600">
          Всего курсов: {currentData.length}
        </div>
      </div>
    </section>
  );
};

export default UnifiedProjectsPage;
